import * as React from 'react';
import { Company, Location, Spacer, Title, TitleLineWrapper } from '../ProfessionalExperienceSectionStyles';
import { language } from '../ProfessionalExperienceSectionLanguage';
import { ProfessionalExperienceEntryType } from '../../../Types/ProfessionalExperienceLineType';
import { useMobile } from '../../../utils/useMobile';

export type Props = {
	entry: ProfessionalExperienceEntryType;
};

export const TitleLine = (props: Props) => {
	const isMobile = useMobile();
	const render = () => {
		const spacer = isMobile ? null : <Spacer />;
		let returnValue = (
			<TitleLineWrapper>
				<Title>{props.entry.title}</Title>
				{spacer}
				<Company>{props.entry.company}</Company>
				{spacer}
				<Location>{props.entry.location}</Location>
			</TitleLineWrapper>
		);
		if (props.entry.noLeftColumn)
			returnValue = (
				<TitleLineWrapper>
					<Title>{props.entry.title}</Title>
					{spacer}
					<Company>{props.entry.company}</Company>
				</TitleLineWrapper>
			);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
